// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login.jsx";
import Main from "./pages/Main.jsx";

import FieldGroups from "./pages/FieldGroups.jsx";
import FieldGroupDetail from "./pages/FieldGroupDetail.jsx";
import FieldDetail from "./pages/FieldDetail.jsx";

import Workers from "./pages/Workers.jsx";
import Tasks from "./pages/Tasks.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import YieldPage from "./pages/YieldPage.jsx";
import NdviPage from "./pages/NdviPage.jsx";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* default */}
        <Route path="/" element={<Navigate to="/main" replace />} />

        {/* auth */}
        <Route path="/login" element={<Login />} />

        {/* main */}
        <Route path="/main" element={<Main />} />

        {/* ✅ FIELDS ENTRY: "Поля" завжди відкриває Groups */}
        <Route path="/fields" element={<Navigate to="/fields/groups" replace />} />

        {/* groups */}
        <Route path="/fields/groups" element={<FieldGroups />} />
        <Route path="/fields/groups/:id" element={<FieldGroupDetail />} />

        {/* field detail */}
        <Route path="/fields/:id" element={<FieldDetail />} />

        {/* other */}
        <Route path="/workers" element={<Workers />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/yield" element={<YieldPage />} />
        <Route path="/ndvi" element={<NdviPage />} />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/main" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
